import memoizee from 'memoizee';
// Memoize デコレータ
export const Memoize = (_target, _propertyKey, descriptor) => {
    if (descriptor.value) {
        descriptor.value = memoizee(descriptor.value);
    }
    return descriptor;
};
